<script setup>

import Search from "./Schedule/Search.vue";
import {onMounted, ref} from "vue";
import Repository from "./Helpers/Repository";
import List from "./Schedule/List.vue";
import Language from "./Helpers/Language";
import Spinner from "./Spinner.vue";

const schedules = ref(null);
const filters = ref({
    day: null,
    tag: null,
    stage: null,
    search: null,
});
const eventDays = ref([]);
let officialStageiD = null;

onMounted(() => {
    new Repository().getEventDays().then((response) => {
        if (response.data['event_days'].length > 0) {
            eventDays.value = response.data['event_days'];
            filters.value.day = eventDays.value[0];
            refreshSchedules();
        }
    })
});

const refreshSchedules = () => {
    new Repository().getSchedules(
        filters.value.day ?? eventDays.value[0],
        filters.value.stage ?? officialStageiD,
        filters.value.tag,
        filters.value.search,
    ).then((response) => {
        schedules.value = sortSchedules(response.data.data ?? []);
    });
}

const sortSchedules = (non_sorted_data) => {
    const ordered_schedules = non_sorted_data.sort((firstSchedule, secondSchedule) => {
        if (new Date(firstSchedule['start']) > new Date(secondSchedule['start'])) {
            return 1;
        }

        if (new Date(firstSchedule['start']) < new Date(secondSchedule['start'])) {
            return -1;
        }

        return 0;
    });

    let grouped_schedules = {};

    ordered_schedules.forEach((schedule) => {
        let date = new Date(schedule['start']).toLocaleTimeString(Language.getLanguage() ?? null, {
            hour: "2-digit",
        });

        if (Language.isPortuguese()) {
            date += ':00';
        }

        if (date in grouped_schedules) {
            grouped_schedules[date].push(schedule);
        } else {
            grouped_schedules[date] = [schedule];
        }
    });

    return grouped_schedules;
}

const searchSchedules = (searchFielters) => {
    filters.value = searchFielters;
    refreshSchedules();
}

function officialStageSchedules(stage_id) {
    officialStageiD = stage_id;
    let new_filters = filters.value;

    new_filters['stage'] = parseInt(officialStageiD);

    if (filters.value.day !== null) {
        refreshSchedules();
    }
}
</script>

<template v-if="eventDays.length > 0 && filters.day !== null">
    <Search @filterSchedules="searchSchedules" :eventDays="eventDays" @officialStage="officialStageSchedules"/>
    <Spinner v-if="schedules === null"/>
    <List v-else :schedules="schedules"/>
</template>

<style scoped>

</style>
